module.exports = __webpack_public_path__ + "static/img/1.47b31d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/1.png
// module id = oWOW
// module chunks = 0